<div (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()"
     (touchend)="onContainerTouchEnd($event)"
     (touchstart)="onContainerTouchStart($event)"
     class="slide-container">
  <!-- Image with Ken Burns effect -->
  @if (currentMedia.type === 'image') {
    <div
        class="slide-media image-slide"
        [ngClass]="currentKenBurnsEffect?.type"
        [class.landscape]="mediaOrientation() === 'landscape'"
        [class.portrait]="mediaOrientation() === 'portrait'"
        [style.--ken-burns-duration.ms]="currentKenBurnsEffect?.duration">
      <!-- Blurred background layer -->
      <div class="slide-background-blur"
           [style.background-image]="'url(' + currentMedia.url + ')'"></div>

      <!-- Main image content -->
      <img
        #imageElement
        [src]="currentMedia.url"
        [alt]="'Slide ' + (slideIndex + 1)"
        class="slide-image"
        (load)="onImageLoad($event)"
        loading="lazy"/>
    </div>
  }

  <!-- Video with player component -->
  @if (currentMedia.type === 'video') {
    <div class="slide-media video-slide"
         [class.landscape]="mediaOrientation() === 'landscape'"
         [class.portrait]="mediaOrientation() === 'portrait'">
      <!-- Blurred background layer for video -->
      <div class="slide-background-blur video-background"></div>

      <!-- Video player component -->
      <app-video-player
        #videoPlayer
        [src]="currentMedia.url"
        [autoplay]="true"
        [loop]="false"
        [controlsVisible]="controlsVisible"
        [mobileControlsVisible]="mobileControlsVisible"
        (timeUpdate)="onVideoTimeUpdate()"
        (ended)="onVideoEnded()"
        (play)="onVideoPlay()"
        (pause)="onVideoPause()"
        (loadedMetadata)="onVideoLoadedMetadata($event)"
        (videoTouchStart)="onVideoTouchStart($event)"
        (videoTouchEnd)="onVideoTouchEnd($event)"
        (controlsTouch)="onVideoControlsTouch()">
      </app-video-player>
    </div>
  }

  <!-- Navigation component -->
  <app-slide-navigation
      (next)="onNextSlide()"
      (previous)="onPreviousSlide()"
      [canGoNext]="canGoNext"
      [canGoPrevious]="canGoPrevious"
      [showArrows]="controlsVisible">
  </app-slide-navigation>
</div>
